var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$options.components['advertisement-loading'] ? [_vm.isLoading ? _c('advertisement-loading') : _vm._e()] : _vm._e(), _vm.productList.length == 0 && !_vm.isLoading ? _c('div', {
    staticClass: "text-center no-item"
  }, [_vm._v(" " + _vm._s(_vm.$t("productStore.noItmes")) + " ")]) : _vm._e(), _vm.productList && _vm.productList.length ? _c('sections-slider', {
    attrs: {
      "list": _vm.productList,
      "subTitle": _vm.$route.params.market,
      "showTitle": true,
      "hasBackground": false,
      "hasButton": false,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          staticClass: "suggester-div w-100",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 3011094852)
  }) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }